import React from 'react';
import PropTypes from 'prop-types';
import ExpandPanel from '../../expandPanel/expandPanel';
import Link from '../../link/link';

/**
 * Cms : DatoCmsComponentLinkCollection
 * 
 * Link Collection in the form of dropdown
 * 
 */
const LinkDropDown = ({data, uniqueid, ...other}) => {
    return (
        data.links.length > 1 ? 
        <ExpandPanel panelClassName={`dropDown`} uniqueid={uniqueid} buttonContent={data.heading} {...other}>
          {                          
            data.links.map((link, i) => (
              <Link data={link}  key={i} icon={false} className="dropDown__link"/>
            ))
          }
        </ExpandPanel>
        :
        <Link data={data.links[0]} {...other}/>
    );
};

LinkDropDown.propTypes = {
  /**
   * CMS Object
   */
  data: PropTypes.shape({
    displayText : PropTypes.string,
    links : PropTypes.array
  }),
  /**
   * ID for panel tags
   */
  uniqueid : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default LinkDropDown;